/*
 * R1 Topic Grid — live search + domain filter chips.
 *
 * Vanilla, no dependencies. Instance-safe: every [data-r1-topic-grid] section on
 * the page wires up its own state, so the section can appear more than once.
 *
 * Behavior:
 *   - Search: case-insensitive "contains" match on each card's data-name.
 *   - Chips: filter by data-domain ("all" shows every domain). Chips combine
 *     with the search term (a card must pass both to stay visible).
 *   - Count line: updates to the "all" label when everything is shown, otherwise
 *     the "some" label. [shown]/[total] tokens are substituted.
 */
(function () {
  function initGrid(root) {
    if (root.dataset.r1TopicGridReady === 'true') return;
    root.dataset.r1TopicGridReady = 'true';

    var searchInput = root.querySelector('[data-r1-topic-search]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-r1-topic-chip]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-r1-topic-card]'));
    var countEl = root.querySelector('[data-r1-topic-count]');

    var query = '';
    var activeDomain = 'all';

    function apply() {
      var q = query.trim().toLowerCase();
      var shown = 0;

      cards.forEach(function (card) {
        var name = (card.getAttribute('data-name') || '').toLowerCase();
        var domain = card.getAttribute('data-domain') || '';
        var matchesSearch = q === '' || name.indexOf(q) !== -1;
        var matchesDomain = activeDomain === 'all' || domain === activeDomain;
        var visible = matchesSearch && matchesDomain;

        card.classList.toggle('is-hidden', !visible);
        if (visible) shown++;
      });

      updateCount(shown);
    }

    function updateCount(shown) {
      if (!countEl) return;
      var total = parseInt(countEl.getAttribute('data-total'), 10) || cards.length;
      var text;
      if (shown === total) {
        text = (countEl.getAttribute('data-label-all') || '')
          .replace('[total]', total)
          .replace('[shown]', shown);
      } else {
        text = (countEl.getAttribute('data-label-some') || '')
          .replace('[shown]', shown)
          .replace('[total]', total);
      }
      countEl.textContent = text;
    }

    if (searchInput) {
      searchInput.addEventListener('input', function (e) {
        query = e.target.value || '';
        apply();
      });
    }

    function selectChip(chip) {
      activeDomain = chip.getAttribute('data-domain') || 'all';
      chips.forEach(function (c) {
        c.classList.toggle('is-active', c === chip);
      });
      apply();
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        selectChip(chip);
      });
    });

    // Deep link: /#topics-<domain-slug> (used by the header's Shop by Topic
    // column headers) pre-selects that domain's chip and scrolls the grid into
    // view. "#topics" alone just scrolls (the section's own anchor id).
    function applyHash() {
      var hash = (window.location.hash || '').replace(/^#/, '');
      var anchor = root.id || 'topics';
      if (hash.indexOf(anchor + '-') !== 0) return;
      var slug = hash.slice(anchor.length + 1);
      var chip = chips.filter(function (c) {
        return c.getAttribute('data-domain-slug') === slug;
      })[0];
      if (!chip) return;
      selectChip(chip);
      root.scrollIntoView({ block: 'start' });
    }

    applyHash();
    window.addEventListener('hashchange', applyHash);
  }

  function initAll() {
    var grids = document.querySelectorAll('[data-r1-topic-grid]');
    Array.prototype.forEach.call(grids, initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the theme editor injects/updates this section.
  document.addEventListener('shopify:section:load', function (e) {
    var grid = e.target.querySelector('[data-r1-topic-grid]');
    if (grid) initGrid(grid);
  });
})();
